import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import BackPage from '../../components/BackPage/BackPage.component';
import BarInfoForm from '../../components/BarInfoForm/BarInfoForm.component';
import BarPOCInfoForm from '../../components/BarPOCInfoForm/BarPOCInfoForm.component';
import Card from '../../components/Card/Card.component';
import GoogleMapLocationPicker from '../../components/GoogleMapLocationPicker/GoogleMapLocationPicker.component';
import LightInput from '../../components/LightInput/LightInput.component';
import LocationPickerInput from '../../components/LocationPickerInput/LocationPickerInput.component';
import PageContainer from '../../components/PageContainer/PageContainer.component';
import { IBar } from '../../models/IBars';
import { DropzoneArea } from 'material-ui-dropzone';


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flex: 1,
        },
        heading: {
            marginBottom: theme.spacing(2)
        },
        editFab: {
            backgroundColor: '#fff',
            color: '#000'
        },
        deleteFab: {
            backgroundColor: '#fff',
            color: 'red',
            marginLeft: theme.spacing(2)
        },
        submitBtn: {
            width: '100%',
            maxWidth: 200,
            margin: 'auto'
        },
        dropzone: {
            backgroundColor: 'rgba(255, 255, 255, 0.35)'
        },
        img: {
            margin: "auto",
            display: "block",
            maxWidth: "300px",
            marginBottom: "1em",
            [theme.breakpoints.up("md")]: {
                maxWidth: "400px",
            }
        }
    })
);



export default function ManageBarPage({
    data,
    onHandleChange,
    onBarLocationSelect,
    onPocAddressLocationSelect,
    valid,
    onSavePress
}) {
    const classes = useStyles();

    return (
        <BackPage>
            <PageContainer>
                <form onSubmit={onSavePress}>
                    <Grid container direction="column">
                        <Grid item>
                            <Typography className={classes.heading} variant="h4" style={{ color: '#fff' }}>Place Details</Typography>
                            <Card>
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <LightInput
                                            type="text"
                                            value={data?.name}
                                            fullWidth placeholder="Name"
                                            onChange={onHandleChange("name")}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <LightInput
                                            type="text"
                                            value={data?.merchantName}
                                            fullWidth 
                                            placeholder="Merchant Name"
                                            onChange={onHandleChange("merchantName")}
                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <GoogleMapLocationPicker
                                            value={data?.address}
                                            lat={data?.lat}
                                            lng={data?.lng}
                                            fullWidth
                                            placeholder="Address"
                                            onChange={onHandleChange("address")}
                                            onSelect={onBarLocationSelect}
                                        />
                                        {(Number.isFinite(data?.lat) && Number.isFinite(data?.lng)) ? (
                                            <Typography variant="caption" style={{ color: "rgba(255,255,255,0.75)", marginTop: 8, display: "block" }}>
                                                Coordinates: {Number(data.lat).toFixed(6)}, {Number(data.lng).toFixed(6)}
                                            </Typography>
                                        ) : null}
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <LightInput
                                            type="text"
                                            value={data?.rewards}
                                            fullWidth
                                            placeholder="Rewards"
                                            onChange={onHandleChange("rewards")}
                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <img
                                            className={classes.img}
                                            src={data?.image?.url}
                                        />
                                        <DropzoneArea
                                            dropzoneClass={classes.dropzone}
                                            onChange={([e]) => onHandleChange("image")(e)}
                                            filesLimit={1}
                                            acceptedFiles={["image/*"]}
                                        />
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                        <Grid item>
                            <Typography className={classes.heading} variant="h4" style={{ color: '#fff' }}>Point of Contact Details</Typography>
                            <Card>
                                <Grid container direction="column" spacing={3}>
                                    <Grid item>
                                        <LightInput
                                            type="text"
                                            value={data?.pocName}
                                            fullWidth
                                            placeholder="Name"
                                            onChange={onHandleChange("pocName")}
                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <LightInput
                                            type="tel"
                                            value={data?.pocPhone}
                                            fullWidth
                                            placeholder="Phone"
                                            onChange={onHandleChange("pocPhone")}

                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <LightInput
                                            type="email"
                                            value={data?.pocEmail}
                                            fullWidth
                                            placeholder="Email"
                                            onChange={onHandleChange("pocEmail")}
                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <LocationPickerInput
                                            value={data?.pocAddress}
                                            fullWidth
                                            placeholder="Address"
                                            onChange={onHandleChange("pocAddress")}
                                            onSelect={onPocAddressLocationSelect}
                                        />
                                    </Grid>
                                    <Grid xs item direction="column">
                                        <LightInput
                                            type="text"
                                            value={data?.pocRole}
                                            fullWidth
                                            placeholder="Role"
                                            onChange={onHandleChange("pocRole")}
                                        />
                                    </Grid>
                                </Grid>
                            </Card>
                        </Grid>
                        <Button
                            className={classes.submitBtn}
                            type="submit"
                            variant="contained"
                            color="primary"
                            disabled={!valid}
                        >
                            Save
                        </Button>
                    </Grid>
                </form>
            </PageContainer>
        </BackPage>
    )
}
